<template>
  <div class="container bg-gray-100 pb-4 pt-5 p-4">
    <router-link
      type="button"
      class="hover:underline block text-left"
      :to="'/'+pathname"
    >
      <!-- <a type="button" class="hover:underline" @click="$router.go(-1)"> -->
      <svg
        class="h-8 w-8 fill-current text-blue-900"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15"
      >
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
        />
      </svg>
      <!-- </a> -->
    </router-link>
    <div class="shadow-2xl bg-white p-4">
    <h1 class="mb-6">
    Cargar identificación con fotografía
    </h1>
      <div class="pb-5">
        <button
          id="button_from_team"
          @click="selectUploadFileMethod('equipo')"
          :class="[selectFromComputer ? 'bg-orange-800' : '']"
          class="px-5 m-4 py-2  w-[30px] rounded bg-orange-500 text-white text-center"
        >
          Desde equipo
        </button>
        <button
          id="button_take_photo"
          @click="selectUploadFileMethod('foto')"
          :class="[selectOpenCamera ? 'bg-orange-800' : '']"
          class="px-5 m-4 py-2  w-[30px] rounded bg-orange-500 text-white text-center"
        >
          Tomar foto
        </button>
        <OpenCameraMobile v-if="selectOpenCamera" />
        <div v-if="selectFromComputer">
        <div class="sm:flex sm:justify-center sm:mt-20">
          <div class="mx-5 text-xl text-slate-700 font-light sm:w-3/4 xl:w-1/3">
            <div>
              <div
                class="w-full py-2 px-5 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none"
                id="input_ine_document"
                v-on:click="getFile('input_ine_if_on_both_sides_documents')"
              >
                <div id="select-file">
                  <button class="italic text-slate-400" type="button">
                    Parte frontal
                  </button>
                  <div style="height: 0px;width:0px; overflow:hidden;">
                    <input
                      id="input_ine_if_on_both_sides_documents"
                      type="file"
                      @change="
                        loadDocument(
                          $event,
                          false,
                          'input_ine_if_on_both_sides_documents',
                          'frontal'
                        )
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="w-full px-5 rounded-md focus:border-blue-600 mb-2 mt-2  focus:outline-none">
                <div v-for="(document, index) in imagesIneIFE" :key="index">
                  <div
                    v-if="document.side === 'FRONTAL'"
                    style="display: flex;width:100%;cursor: pointer;margin-top:10px;margin-bottom:10px"
                    @click="delete_element(imagesIneIFE, index)"
                  >
                    <div style="width:90%;">{{ document.name }}</div>
                    <div style="width:10%;text-align: right;">
                      <strong>X</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div
                class="w-full py-2 px-5 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none"
                :class="{'bg-gray-400 opacity-50': disbaleSelectPosterior }"
                id="input_address_documents"
                v-on:click="getFile('input_proof_of_address_documents')"
              >
                <div id="select-file">
                  <button class="italic" type="button">
                    Parte posterior
                  </button>
                  <div style="height: 0px;width:0px; overflow:hidden;">
                    <input
                      id="input_proof_of_address_documents"
                      type="file"
                      :disabled="disbaleSelectPosterior"
                      :accept="documentsAllowed.join(',')"
                      @change="
                        loadDocument(
                          $event,
                          false,
                          'input_proof_of_address_documents',
                          'reverso'
                        )
                      "
                    />
                  </div>
                </div>
              </div>
              

              <div class="w-full px-5 rounded-md focus:border-blue-600 mb-2 mt-2  focus:outline-none">
                <div v-for="(document, index) in imagesIneIFE" :key="index">
                  <div
                    v-if="document.side === 'POSTERIOR'"
                    style="display: flex;width:100%;cursor: pointer;margin-top:10px;margin-bottom:10px"
                    @click="delete_element(imagesIneIFE, index)"
                  >
                    <div style="width:90%;">{{ document.name }}</div>
                    <div style="width:10%;text-align: right;">
                      <strong>X</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <label class="text-sm text-left italic text-slate-400"
                >**Peso máximo permitido 1.4 MB:</label
              >
              <br />
              <label class="text-sm text-left italic"
                >**Documentos permitidos:
                {{ documentsAllowed.join(", ") }}:</label
              >

            
          </div>
        </div>
        <div class="mt-10 w-1/2 mx-auto px-5 sm:text-center">
              <button
                class="px-5 py-2 w-full bg-orange-500  text-white text-center"
                :class="{
                  'opacity-100': showButtonNext == true,
                  'opacity-50': showButtonNext == false,
                }"
                @click="next_page()"
              >
                Siguiente
              </button>
        </div>
      </div>
      </div>
      <Loading :height="15"
                 color="#000"
                 class="static"
                 :active="isLoading"
                 loader="dots"
                 :can-cancel="true"
                 :is-full-page="false" />
      
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import axios from "axios";
//import OpenCamera from '../components/OpenCamera';
import { getPathNameToSorage } from '../helpers/pathName';
import { isApProductInStorage } from '../helpers/isApProductInStorage';

import OpenCameraMobile from "../components/OpenCameraMobile";
import Loading from 'vue-loading-overlay';

export default {
  name: "CargaIdentificacion",
  components: {
    OpenCameraMobile,
    Loading,
  },
  setup() {
    const selectFromComputer = ref(false);
    const selectOpenCamera = ref(false);
    const ccapi = process.env.VUE_APP_CCAPI + 'cabsaaye/documents/upload';
    const rfcDocument = ref("");
    const disbaleSelectPosterior = ref(true);
    const router = useRouter();
    const documentsAllowed = ["jpg", "png", "pdf", "jpeg"];
    const imagesIneIFE = ref([]);
    let isLoading = ref(false);
    const pathname = getPathNameToSorage("pathname");

    onBeforeMount(() => {
      const selected_products = JSON.parse(localStorage.getItem("policy"))?.client?.selected_products;
      
      if(!isApProductInStorage(selected_products.details)){
        localStorage.setItem("beneficiaryArray", JSON.stringify([]))
      }
    })
    
    onMounted(() => {
      getRFCStorage();
      getFilesFromStorage();
      const listDocs = document.querySelector("#listaDeDispositivos");
      console.log(listDocs);
    });
    const getItemFromStorage = (item) => {
      return localStorage.getItem(item) || "[]";
    }
     
    const getFilesFromStorage = () => {
      const docs = JSON.parse(getItemFromStorage("docs"));
      if(docs.length > 0){
        imagesIneIFE.value = docs;
        disbaleSelectPosterior.value = false;
        selectFromComputer.value = true;
      }
      

    }
    const getRFCStorage = () => {
      const rfc_applicant = localStorage.getItem("rfc_applicant");
      const rfc_client = localStorage.getItem("rfc_client");
      if(rfc_client !== null){
        rfcDocument.value = rfc_client;
      }
      else{
        rfcDocument.value = rfc_applicant
      }
    }
   

    function getFile(id_input_file) {
      console.log("click: ",id_input_file)
      document.getElementById(id_input_file)?.click();
    }

    function validateTypeFormat(formats, typeFormat) {
      for (const format of formats) {
        if (format === typeFormat) return true;
      }
      return false;
    }
    function get_document_attributes(document) {
      const attributes = {};
      //attributes.name = document.name;
      attributes.extension = document.type.split("/")[1];
      attributes.completeExtension = `.${document.type.split("/")[1]}`;
      attributes.size = parseInt(document.size);

      return attributes;
    }

    function exceedTheMaximunSize(maxSize, size) {
      return size > maxSize;
    }
    async function upload_documents(document) {
      /* Mock */
      const docs = document.map((doc) => {
        return {
            document_type: "INE " + doc.side.toUpperCase(),
            name: "INE",
            extension: "jpeg",
            file_base64: doc.base64_file,
          }
      })
      const data = {
        token_auth: "eyJhbGciOiJIUzI1NiJ9.eyJhcGlrZXkiOiIwdTNoSlNabEJ4Y0RaUDlUOUo0aHJ3IiwidmVyc2lvbiI6InYxIiwiZXhwIjoxNjcwNjA2Njk0fQ.HkHLjS-lbZUHe_mt5rk_qTh48yQW73V4eBp7MZI63t8",
        rfc: rfcDocument.value,
        folio: "",
        documents: docs,
      };
      return await axios.post(`${ccapi}`,data);
    }
    
    async function next_page() {
      isLoading.value = true;
      console.log("imagesIneIFE: next_page", imagesIneIFE.value)
      if (imagesIneIFE.value.length > 0) {
          localStorage.setItem("docs", JSON.stringify(imagesIneIFE.value));
          const response_imagesIneIFE = await upload_documents(imagesIneIFE.value);
          const document_list = response_imagesIneIFE.data.response.result;
          const documents = []; 
          document_list.map((data) => {
            const side = data.document_name.split('_')[2];
            if(side === "FRONTAL"){
                const cloud_key = data.url.split("/")[6];
                documents[0] = {
                  nameStorage: imagesIneIFE.value[0].side === "FRONTAL" ? imagesIneIFE.value[0].name : imagesIneIFE.value[1].name,
                  cloud_url: data.url,
                  document_name: data.document_name,
                  document_type: "INE FRONTAL",
                  cloud_key,
                }
              }
              if(side === "POSTERIOR"){
                const cloud_key = data.url.split("/")[6];
                documents[1] = {
                  nameStorage: imagesIneIFE.value[0].side === "POSTERIOR" ? imagesIneIFE.value[0].name : imagesIneIFE.value[1].name,
                  cloud_url: data.url,
                  document_name: data.document_name,
                  document_type: "INE POSTERIOR",
                  cloud_key,
                }
              }
            
          })
           if(response_imagesIneIFE.status==200){
            let policy =  JSON.parse(localStorage.getItem("policy"));
            policy.document_list = documents;
            localStorage.setItem("policy", JSON.stringify(policy));
            router.push({name: 'resume'})
          } 
      } else {
        isLoading.value = false;
        Swal.fire({
          title: "Aviso",
          html: `Por lo menos tienes que subir un documento de INE/IFE`,
          icon: "error",
        });
      }
    }

    async function convert_to_base64(file) {
      const fileReader = new FileReader();
      return await new Promise((resolve, reject) => {
        fileReader.onload = (fileEvent) => {
          const fileBase64 = fileEvent.target.result.split(",")[1];
          resolve(fileBase64);
        };
        fileReader.onerror = () => {
          reject("error, something went wrong with the file reader.");
        };
        fileReader.readAsDataURL(file);
      });
    }
    function delete_image_in_list(listOfImages, objetName) {
      listOfImages.map((images, index) => {
        const keys = Object.keys(images);
        if (keys.includes("base64_file")) {
          if (images.name.split(".")[0] == objetName.name.split(".")[0]) {
            listOfImages.splice(index, 1);
          }
        }
        return images;
      });
    }
    /* async function delete_documents(document) {
      const axios = axios(
        `${process.env.VUE_APP_GSAPI}/api/v1/documents/delete`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localStorage.getItem("tokenAccess")}`,
          },
        },
        {
          documents_urls: document,
          process_name: "vida_simple",
        }
      );
      return await axios.httpPost();
    } */
    

    async function delete_element(element, position) {
      Swal.fire({
        icon: "warning",
        title: "Cuidado!",
        text: "¿Seguro que desea eliminar este archivo?",
        confirmButtonText: "Si",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        // confirmButtonColor: '#FEB72B',
        // cancelButtonColor: '#FFFFFF',
      }).then(async (result) => {
        
        if (result.value) {
          isLoading.value = true;
            //const response = await delete_documents([element[position].url]);
              const documentStorage = JSON.parse(getItemFromStorage("policy"));
              if(documentStorage.document_list !== undefined && documentStorage.document_list.length > 0){
                documentStorage.document_list.splice(position, 1);
                localStorage.setItem("policy", JSON.stringify(documentStorage));
              }
              const docs = JSON.parse(getItemFromStorage("docs"));
              if(docs !== undefined && docs.length > 0){
                docs.splice(position, 1);
                localStorage.setItem("docs", JSON.stringify(docs));
              }
              element.splice(position, 1);
              Swal.fire({
                title: "Tarea terminada",
                html: `El archivo fue eliminado`,
                icon: "success",
              });
          }
          if(element.length === 0){
            disbaleSelectPosterior.value = true;
          }
          isLoading.value = false;
        });
    }
    
    function arrayLengthGratherOne(array, propValue) {
      const values = array.filter(obj =>  obj.side == propValue);
      console.log("values:" ,values);
      return values.length > 0;
    }
    async function loadDocument(event, isDrag, id_of_input, tipo) {
      let files = [];
      if (isDrag) files = event.dataTransfer.files;
      else files = event.target.files;
      console.log(tipo);
      console.log()
        if(files?.length > 1){
          Swal.fire({
              title: "Aviso",
              html: `Sólo puedes subir 1 archivo`,
              icon: "warning",
            });
          return;
        }
      console.log("event: ", files );
      
      

      for (const file of files) {
        const filenameSplit = file.name.split(".");
        const filenameExtension = filenameSplit[filenameSplit.length - 1]
        
        const isValidFormat = validateTypeFormat(
          documentsAllowed,
          filenameExtension
        );

        if (!isValidFormat) {
          Swal.fire({
            title: "Aviso",
            html: `La extensión del archivo seleccionado no es permitido. <br /> (Documentos permitidos: jpg, png, pdf, jpeg)`,
            icon: "error",
          });
          imagesIneIFE.value = [];
          return;
        }


        const compressed_image = await compress_Image(file, 50);
        const fileAttributes = get_document_attributes(compressed_image);
        const theMaximunSize = exceedTheMaximunSize(
          1487653,
          fileAttributes.size
        );
        fileAttributes.name = file.name;

         if (id_of_input == "input_ine_if_on_both_sides_documents") {
           fileAttributes.side = 'frontal';
         }


        if (theMaximunSize) {
          Swal.fire({
            title: "Aviso",
            html: `El peso del archivo sobrepasa 
                            el limite establecido de <span style="font-weight: 700;"> ${1.4} MB`,
            icon: "error",
          });
          return;
        }

        

        const base64image = await convert_to_base64(compressed_image);

        if (id_of_input == "input_ine_if_on_both_sides_documents") {
          if (imagesIneIFE.value.length >= 0 && imagesIneIFE.value.length < 2) {
            let isExist = 0;
            imagesIneIFE.value.forEach((element) => {
              if (element.name == fileAttributes.name) {
                isExist++;
              }
            });

            if (isExist > 0) {
              Swal.fire({
                title: "Aviso",
                html: `Este documento con el nombre <strong>${fileAttributes.name} </strong> ya existe.`,
                icon: "error",
              });
              return;
            } else {
              const resp = arrayLengthGratherOne(imagesIneIFE.value, "FRONTAL");
              console.log(resp);
              if(resp){
                Swal.fire({
                  title: "Aviso",
                  html: `Solo puedes subir un documento.`,
                  icon: "warning",
                });
                return;
              }
                imagesIneIFE.value.push({
                side: "FRONTAL",
                name: fileAttributes.name,
                extension: fileAttributes.extension,
                base64_file: base64image,
              });
              
              
            }
          } else {
            //imagesIneIFE.value.push({name:fileAttributes.name,extension:fileAttributes.extension,base64_file:base64image});
            Swal.fire({
              icon: "warning",
              title: "Cuidado!",
              text: "Solo se permite 1 archivo máximos.",
            });
          }
        }
        else if(id_of_input == "input_proof_of_address_documents"){
          let isExist = 0;
            imagesIneIFE.value.forEach((element) => {
              if (element.name == fileAttributes.name) {
                isExist++;
              }
            });

            if (isExist > 0) {
              Swal.fire({
                title: "Aviso",
                html: `Este documento con el nombre <strong>${fileAttributes.name} </strong> ya existe.`,
                icon: "error",
              });
              return;
            } else {
              const resp = arrayLengthGratherOne(imagesIneIFE.value, "POSTERIOR");
              console.log(resp);
              if(resp){
                Swal.fire({
                  title: "Aviso",
                  html: `Solo puedes subir un documento.`,
                  icon: "warning",
                });
                return;
              }
              imagesIneIFE.value.push({
                side: "POSTERIOR",
                name: fileAttributes.name,
                extension: fileAttributes.extension,
                base64_file: base64image,
              });
            }
            console.log("imagesIneIFE.value: ", imagesIneIFE.value);
      
        }

      }

      event.target.value = "";
      disbaleSelectPosterior.value = false;
    }

    const compress_Image = (imagenComoArchivo, porcentajeCalidad) => {
      if(imagenComoArchivo.type === "application/pdf"){
        return imagenComoArchivo;
      }
      return new Promise((resolve, reject) => {
        const $canvas = document.createElement("canvas");

        const imagen = new Image();
        imagen.onload = () => {
          $canvas.width = imagen.width;
          $canvas.height = imagen.height;
          $canvas.getContext("2d")?.drawImage(imagen, 0, 0);
          $canvas.toBlob(
            (blob) => {
              if (blob === null) {
                return reject(blob);
              } else {
                resolve(blob);
              }
            },
            "image/jpeg",
            porcentajeCalidad / 100
          );
        };
        imagen.src = URL.createObjectURL(imagenComoArchivo);
      });
    };

    const selectUploadFileMethod = (medio) => {
      if (medio === "equipo") {
        selectFromComputer.value = true;
        selectOpenCamera.value = false;
      }
      if (medio === "foto") {
        selectOpenCamera.value = true;
        selectFromComputer.value = false;
      }
    };
    return {
      documentsAllowed,
      loadDocument,
      imagesIneIFE,
      getFile,
      delete_image_in_list,
      delete_element,
      next_page,
      selectUploadFileMethod,
      selectFromComputer,
      selectOpenCamera,
      disbaleSelectPosterior,
      pathname,
      isLoading,
    };
  },
};
</script>
